export default "__VITE_ASSET__BcAeIJfY__"